import apiClient from './apiClient';

export interface QueryParams {
  emp_code_from?: string;
  emp_code_to?: string;
}

export interface ReportRow {
  F11K_01: string;   // 員工代號 (short code)
  F11K_11: string;   // 員工人事代號
  emp_name: string;  // 員工姓名
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  message?: string;
}

export const p131kApi = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/p131k/query', params);
    return res.data;
  },
};
